import api from './apiClient'

export default {
  /**
   * 📋 Get users list (with filters & pagination)
   */
  async getUsers(params = {}) {
    const res = await api.get('users', {
      params
    })
    return res.data
  },

  /**
   * ➕ Invite user
   */
  async inviteUser(data) {
    try {
      const res = await api.post('users/invite', data)
      return res.data
    } catch (error) {
      const err = error.response

      throw {
        status: err?.status,
        message: err?.data?.message || 'Something went wrong',
        errors: err?.data?.errors || {}
      }
    }
  },

  async resendInvitation(user_id) {
   try {
      const res = await api.post(`users/${user_id}/resend-invite`)
      return res.data
    } catch (error) {
      const err = error.response

      throw {
        status: err?.status,
        message: err?.data?.message || 'Something went wrong',
        errors: err?.data?.errors || {}
      }
    }
  },

  /**
   * 👤 Get single user
   */
  async getUser(id) {
    const res = await api.get(`/users/${id}`)
    return res.data.data
  },

  

  /**
   * ✏️ Update user
   */
  async updateUser(id, data) {
    try {
      const res = await api.put(`/users/${id}`, data)
      return res.data
    } catch (error) {
      const err = error.response

      throw {
        status: err?.status,
        message: err?.data?.message || 'Something went wrong',
        errors: err?.data?.errors || {}
      }
    }
  },

  /**
   * ❌ Delete user
   */
  async deleteUser(id) {
    const res = await api.delete(`/users/${id}`)
    return res
  },

  /**
   * 🔄 Activate user
   * */
  async activateUser(id) {
    const res = await api.post(`/users/${id}/restore`)
    return res
  },

  getProfile() {
    return api.get('/users/me')
  },

  async updateProfile(data) {
    try {
      const res = await api.put('/users/me', data)
      return res.data
    } catch (error) {
      const err = error.response

      throw {
        status: err?.status,
        message: err?.data?.message || 'Something went wrong',
        errors: err?.data?.errors || {}
      }
    }
  },

  async changePassword(data) {
     try {
      const res = await api.put('/users/me', data)
      return res.data
    } catch (error) {
      const err = error.response

      throw {
        status: err?.status,
        message: err?.data?.message || 'Something went wrong',
        errors: err?.data?.errors || {}
      }
    }
  },
  

}